import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';

interface MedicalSupplyMethodSelectProps {
  value: number;
  onSupplyMethodChange: (value: number) => void;
  cssClass?: string;
  allowAny?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
}

const MedicalSupplyMethodSelect = ({
  value,
  onSupplyMethodChange,
  allowAny,
  cssClass,
  fullWidth,
  disabled
}: MedicalSupplyMethodSelectProps) => {
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as number;

    //callback
    onSupplyMethodChange && onSupplyMethodChange(value);
  };

  return (
    <FormControl className={cssClass} variant="outlined" size="small" fullWidth={fullWidth} disabled={disabled}>
      <InputLabel id="supplyMethod">{t('f-supplies-method')}</InputLabel>
      <Select
        label={t('f-supplies-method')}
        labelId="supplyMethod"
        id="supplySelect"
        value={value}
        onChange={handleChange}
      >
        {allowAny && <MenuItem value={0}>{t('f-any')}</MenuItem>}
        <MenuItem value={10}>{t('f-supplies-method-muscular')}</MenuItem>

        <MenuItem value={20}>{t('f-supplies-method-oral')}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default MedicalSupplyMethodSelect;
